import { jwtDecode } from "jwt-decode";

type JwtWithCompanies = {
  companies?: string;
};

export function parseJwtCompanies(token: string | null | undefined): string[] {
  if (!token) return [];

  try {
    const { companies } = jwtDecode<JwtWithCompanies>(token);
    if (!companies) return [];

    const parsed = JSON.parse(companies);
    return Array.isArray(parsed)
      ? parsed.filter((id): id is string => typeof id === "string")
      : [];
  } catch {
    return [];
  }
}
